// FETCH ALL PROPERTIES FROM SEASON MASTER
export const FETCH_SEASON_MASTER_REQUEST = 'FETCH_SEASON_MASTER_REQUEST';
export const FETCH_SEASON_MASTER_SUCCESS = 'FETCH_SEASON_MASTER_SUCCESS';
export const FETCH_SEASON_MASTER_FAILURE = 'FETCH_SEASON_MASTER_FAILURE';

// CREATE PROPERTIES FOR SEASON MASTER
export const CREATE_SEASON_MASTER_REQUEST = 'CREATE_SEASON_MASTER_REQUEST';
export const CREATE_SEASON_MASTER_SUCCESS = 'CREATE_SEASON_MASTER_SUCCESS';
export const CREATE_SEASON_MASTER_FAILURE = 'CREATE_SEASON_MASTER_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_SEASON_MASTER = 'CREATE_USER_FORM_SEASON_MASTER';


// UPDATE PROPERTIES FOR SEASON MASTER
export const UPDATE_SEASON_MASTER_REQUEST = 'UPDATE_SEASON_MASTER_REQUEST';
export const UPDATE_SEASON_MASTER_SUCCESS = 'UPDATE_SEASON_MASTER_SUCCESS';
export const UPDATE_SEASON_MASTER_FAILURE = 'UPDATE_SEASON_MASTER_FAILURE';

// FETCH SINGLE SEASON
export const FETCH_SINGLE_SEASON_MASTER_REQUEST = 'FETCH_SINGLE_SEASON_MASTER_REQUEST';
export const FETCH_SINGLE_SEASON_MASTER_SUCCESS = 'FETCH_SINGLE_SEASON_MASTER_SUCCESS';
export const FETCH_SINGLE_SEASON_MASTER_FAILURE = 'FETCH_SINGLE_SEASON_MASTER_FAILURE';

// DELETE PROPERTIES FOR SEASON MASTER
export const DELETE_SEASON_MASTER_REQUEST = 'DELETE_SEASON_MASTER_REQUEST';
export const DELETE_SEASON_MASTER_SUCCESS = 'DELETE_SEASON_MASTER_SUCCESS';
export const DELETE_SEASON_MASTER_FAILURE = 'DELETE_SEASON_MASTER_FAILURE';

// USERFORM RESET

export const SEASON_MASTER_USERFORM_RESET = 'SEASON_MASTER_USERFORM_RESET';
